import { EXPERIMENTS } from "@/data/experiments";
import { SITE, url } from "@/data/site";
import PageShell from "@/components/PageShell";
import ExperimentsPreview from "@/components/home/ExperimentsPreview";
import { PageTitle, Section } from "@/components/shared/Primitives";

const CANONICAL = url("/experiments");

const JSON_LD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "CollectionPage",
      name: "Experiments — Elentara",
      url: CANONICAL,
      description:
        "Ongoing creative technology R&D from Elentara: shader studies, generative type, spatial interfaces, fluid simulation and audio-reactive geometry.",
      isPartOf: { "@id": `${SITE.base}/#website` },
      about: { "@id": `${SITE.base}/#organization` },
      mainEntity: {
        "@type": "ItemList",
        itemListElement: EXPERIMENTS.map((e, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: e.title,
          url: url(`/experiments/${e.slug}`),
        })),
      },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Elentara", item: url("/") },
        { "@type": "ListItem", position: 2, name: "Experiments", item: CANONICAL },
      ],
    },
  ],
};

const EXPERIMENTS_SEO = {
  title: "Experiments — Creative Technology R&D Lab | Elentara",
  description:
    "The Elentara experiments lab: shader studies, generative typography, spatial interface tests, fluid simulation and audio-reactive geometry. Ongoing R&D, not client work.",
  canonical: CANONICAL,
  image: EXPERIMENTS[0].image,
  jsonLd: JSON_LD,
};

export default function Experiments() {
  return (
    <PageShell
      testId="experiments-page"
      finalCtaFrom="experiments"
      seo={EXPERIMENTS_SEO}
    >
      <Section testId="experiments-hero" className="!pt-36 !pb-8">
        <PageTitle
          overline="Experiments"
          testId="experiments-title"
          title="Experiments"
          lead="Elentara is not only a service studio — it is an active creative technology laboratory. Each study answers one question, and each one is labelled R&D."
        />
      </Section>
      <ExperimentsPreview />
    </PageShell>
  );
}
